// extracted by mini-css-extract-plugin
module.exports = {"post":"Instagram_post__2ZlJ5"};